import { z } from 'zod';
export const postReportPageSchema = z
    .object({
    type: z.literal('page'),
    name: z.string(),
    pageId: z.string(),
})
    .strict();
export const postReportDocumentSchema = z
    .object({
    type: z.literal('document'),
    name: z.string(),
    documentId: z.string(),
})
    .strict();
export const postReportGCSFileSchema = z
    .object({
    type: z.literal('gcs'),
    name: z.string(),
    gcsPath: z.string(),
})
    .strict();
export const postReportFolderSchema = z
    .object({
    type: z.literal('folder'),
    name: z.string(),
    children: z.lazy(() => childrenSchema),
})
    .strict();
const childrenSchema = z.array(z.discriminatedUnion('type', [
    //-
    postReportPageSchema,
    postReportDocumentSchema,
    postReportGCSFileSchema,
    z.lazy(() => postReportFolderSchema),
]));
export const postReportPdfPageSchema = z
    .object({
    type: z.literal('page'),
    pageId: z.string(),
})
    .strict();
export const postReportPdfDocumentSchema = z
    .object({
    type: z.literal('document'),
    documentId: z.string(),
})
    .strict();
export const postReportBodySchema = z.union([
    z.object({
        projectId: z.string(),
        type: z.literal('zip'),
        structure: z.lazy(() => childrenSchema),
    }),
    z.object({
        projectId: z.string(),
        type: z.literal('pdf'),
        entries: z.array(z.discriminatedUnion('type', [postReportPdfPageSchema, postReportPdfDocumentSchema])),
    }),
]);
//# sourceMappingURL=api-reports.api.schema.js.map